import styled from 'styled-components';

import { theme } from '../../styles/theme';

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding-top: 45px;

  span {
    z-index: 10;
    cursor: pointer;
    color: ${theme.colors.textLight};
    padding: 0 0 4px 15px;
  }

  div {
    display: flex;
    align-items: center;
  }

  h1 {
    padding-left: 63px;
    font-size: 7rem;
    color: ${theme.colors.textLight};
    position: relative;
    z-index: 1;

    span {
      color: ${theme.colors.text};
      position: absolute;
      font-size: 8rem;
      opacity: 0.2;
      bottom: 10px;
      left: 24px;
      z-index: -1;
    }
  }

  a {
    font-size: 16px;
    line-height: 24px;
    color: ${theme.colors.textLight};
    padding-left: 24px;
    z-index: 20;
  }

  @media (max-width: 1100px) {
    margin: 0;

    h1 {
      font-weight: 700;
      font-size: 31px;
      line-height: 44px;
      padding-bottom: 14px;

      span {
        display: none;
      }
    }
  }
`;

export const Content = styled.section`
  padding: 60px 190px;

  div {
    h1 {
      margin-bottom: 30px;
      font-family: Lato;
      font-style: normal;
      font-weight: bold;
      font-size: 32px;
      line-height: 40px;
    }

    p {
      margin-bottom: 10px;
      font-family: Lato;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 28px;
      color: ${theme.colors.text};
    }
  }
  @media (max-width: 480px) {
    width: 100%;
    padding: 0;
    margin-bottom: 30px;

    div {
      min-width: 300px;
      width: 80%;
      margin: 0 auto;

      h1 {
        font-weight: bold;
        font-size: 24px;
        line-height: 32px;
        text-align: center;
        margin-top: 30px;
      }

      p {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  * {
    background-color: ${theme.colors.shape};
  }
`;

export const ImageFilter = styled.small`
  background: linear-gradient(
    90deg,
    rgba(89, 74, 173, 0.83) -5.53%,
    rgba(159, 151, 201, 0.3818) 60.04%,
    rgba(47, 24, 156, 0.83) 131.32%
  );
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.3;
  width: 100%;
  height: 100%;
`;


export const Background = styled.div`
  width: 100%;
  padding-top: 120px;
  height: 400px;
  position: relative;

  @media (max-width: 1280px) {
    height: 400px;
  }
  @media (max-height: 900px) {
    width: 100%;
    height: 400px;
  }
  @media (max-width: 480px) {
    width: 100%;
    height: 226px;
  }

  > img {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    height: 400px;
    max-height: 428px;
    object-fit: cover;
    @media (max-width: 1280px) {
      height: 400px;
    }
    @media (max-height: 900px) {
      width: 100%;
      height: 400px;
    }
    @media (max-width: 480px) {
      width: 100%;
      height: 226px;
    }
  }

  h1 {
    font-weight: bold;
    font-size: 80px;
    padding: 30px 90px;
    letter-spacing: 0.05em;
    color: #ffffff;
  }

  h2 {
    position: absolute;
    left: 40px;
    top: 155px;
    font-weight: bold;
    font-size: 90px;
    line-height: 120px;
    letter-spacing: 0.05em;
    color: #2f189c;
    mix-blend-mode: multiply;
    opacity: 0.1;
    text-shadow: 0 2px 4px rgba(24, 39, 75, 0.12),
      0 4px 4px rgba(24, 39, 75, 0.08);
  }
`;
